import axios from 'axios';
import {
  EDITOR_LOAD_EVENTS_BEGIN,
  EDITOR_LOAD_EVENTS_SUCCESS,
  EDITOR_LOAD_EVENTS_FAILURE,
  EDITOR_LOAD_EVENTS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
export function loadEvents(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EDITOR_LOAD_EVENTS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/events?noActions=false`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EDITOR_LOAD_EVENTS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EDITOR_LOAD_EVENTS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadEventsError() {
  return {
    type: EDITOR_LOAD_EVENTS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_LOAD_EVENTS_BEGIN:
      return {
        ...state,
        loadEventsPending: true,
        loadEventsError: null,
      };

    case EDITOR_LOAD_EVENTS_SUCCESS:
      return {
        ...state,
        loadEventsPending: false,
        loadEventsError: null,
        events: action.data,
      };

    case EDITOR_LOAD_EVENTS_FAILURE:
      return {
        ...state,
        loadEventsPending: false,
        loadEventsError: action.data.error,
      };

    case EDITOR_LOAD_EVENTS_DISMISS_ERROR:
      return {
        ...state,
        loadEventsError: null,
      };

    default:
      return state;
  }
}
